import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { UserService } from '../services/user.service';

export const AuthorizedGuard: CanActivateFn = () => {
  const userService = inject(UserService);
  const router = inject(Router);

  const user = userService.getUserInfo();
  if (user) {
    return true; // User info, allow access to page (all main layout pages, currently, since it is assigned to the main layout)
  }
  return router.createUrlTree(['/logout']); // No user info available, they haven't been signed in, redirect back to login page
};
